import Types from 'types/types'

/**
 * List of Columns
 * @type {import('types/column').Column[]}
 * @readonly
 */
const PhoneTemplatesColumns = [
    {
        fieldName: 'type',
        name: 'Type',
        type: Types.STRING,
    },
    {
        fieldName: 'name',
        name: 'Nom',
        type: Types.STRING,
    },
    {
        fieldName: 'phone',
        name: 'Téléphone',
        type: Types.STRING,
    },
]

export default PhoneTemplatesColumns
